export const VICTIMS_LOAD_PER_PAGE = 42;
export const VICTIMS_SEARCH_DEBOUNCE_MS = 500;
export const PREFERRED_SLUG_DEBOUNCE_MS = 500;

export const victimStatuses = ["approved", "waiting", "rejected"] as const;
export const sexes = ["male", "female"] as const;
export const iconColors = {
  red: "#FF0000",
  blue: "#77B7F7",
  white: "#FFFFFF",
} as const;
export const locales = ["ua", "en"] as const;
